import React from 'react';
import styled from 'styled-components';

const LogoImage = styled.img`
  height: 85px;
  width: auto;
  display: inline-block;
  vertical-align: middle;
  
  @media (max-width: 768px) {
    height: 63px;
  }
`;

const MasMediaLogo: React.FC = () => {
  return (
    <LogoImage 
      src="/mas-media-deportes-logo.png" 
      alt="+Media" 
    />
  );
};

export default MasMediaLogo;